"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerUIScreenType = void 0;
var ChargerUIScreenType;
(function (ChargerUIScreenType) {
    ChargerUIScreenType[ChargerUIScreenType["Available"] = 1] = "Available";
    ChargerUIScreenType[ChargerUIScreenType["Instructions"] = 2] = "Instructions";
    ChargerUIScreenType[ChargerUIScreenType["Charging"] = 3] = "Charging";
    ChargerUIScreenType[ChargerUIScreenType["PleaseUnplug"] = 4] = "PleaseUnplug";
    ChargerUIScreenType[ChargerUIScreenType["Receipt"] = 5] = "Receipt";
    ChargerUIScreenType[ChargerUIScreenType["ChargerResetAfterFailure"] = 6] = "ChargerResetAfterFailure";
    ChargerUIScreenType[ChargerUIScreenType["Unavailable"] = 7] = "Unavailable";
})(ChargerUIScreenType = exports.ChargerUIScreenType || (exports.ChargerUIScreenType = {}));
